export enum EEmployerLStoreKeys {
  interviewData = 'interview-data',
}
